
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.044 24.861v-3.46h3.3c2.319 0 4.77-.608 4.802-2.69 0-1.281-1.046-2.979-4.705-2.979-2.026 0-4.77.705-4.77 2.755H.36c0-4.837 4.9-6.599 9.115-6.599 4.313 0 8.952 2.05 8.985 6.823 0 1.762-1.176 3.812-3.17 4.42 2.19.705 3.725 2.82 3.725 4.709 0 5.477-5.26 7.11-9.67 7.11-4.346 0-9.312-1.793-9.345-6.886h4.345c0 2.306 3.17 3.107 5.032 3.107 2.189 0 5.097-.897 5.097-3.3 0-1.344-.752-3.01-4.868-3.01H6.044zM26.236 19.094v3.364c1.013-1.538 3.496-2.37 5.293-2.37 4.607 0 9.442 1.889 9.442 7.463 0 4.965-4.868 7.43-9.474 7.43-4.672 0-9.54-2.465-9.54-7.494v-8.36c0-4.998 4.705-7.335 9.41-7.335 4.966 0 9.376 1.922 9.376 6.63h-4.312c0-1.986-2.548-2.979-4.999-2.979-2.581-.032-5.195 1.346-5.195 3.779v-.128zm10.455 8.457c0-2.467-2.287-3.779-5.162-3.779s-5.326 1.282-5.293 3.779c.033 2.466 2.45 3.651 5.26 3.651 2.714 0 5.196-1.185 5.196-3.651zM60.87 16.211H48.517v3.94h4.445c4.868 0 9.213 1.954 9.18 7.207 0 5.094-4.345 7.528-8.951 7.528-5.032 0-9.345-1.762-9.377-7.015h4.278c0 2.466 2.875 3.107 5.032 3.107 2.09 0 4.737-.96 4.737-3.62.033-2.53-2.548-3.267-4.9-3.267h-8.658V12.24H60.87v3.972zM95.98 0a4.02 4.02 0 00-1.934 7.545l-8.155 19.984a4.02 4.02 0 00-3.384.35l-8.668-9.923a4.014 4.014 0 10-1.072.938l8.669 9.923a4.003 4.003 0 00-.882 2.51c0 2.22 1.578 4.02 4.02 4.02 2.443 0 4.02-1.8 4.02-4.02a4.011 4.011 0 00-1.453-3.093l8.258-20.236A4.02 4.02 0 1095.98 0z","fill":"#3DAFB8"}})])
          )
        }
      }
    